import moment from "moment"
import { Validator } from "../validator"

enum DateOfBirthError {
    PATTERN = `errors.date`,
    MIN = `errors.age`,
    EMPTY = `errors.required`,
}

const MIN = 16
const MINYEAR = 1900

class DateOfBirtValidator implements Validator<Date, DateOfBirthError> {
    validate(value: Date | null): DateOfBirthError | undefined {

        if (value === null) {
            return DateOfBirthError.EMPTY
        }

        const input = moment(value)

        // if input is 34/62/2454
        if (!input.isValid()) {
            return DateOfBirthError.PATTERN
        }

        const years = input.year()
        if (years < MINYEAR) {
            return DateOfBirthError.PATTERN
        }

        const diff = moment().diff(input, `years`)
        if (diff < MIN) {
            return DateOfBirthError.MIN
        }
    }
}

export default DateOfBirtValidator
export { DateOfBirthError }
